skrilla.controller('selectPlayerModalCtrl', function ($scope, searchService, paginationService, queryService, cacheService, modalService, $mdDialog) {
    $scope.sport = cacheService.getObjectOrElse("sport", function(){modalService.dismissAll()});
    console.log("sport", $scope.sport)
    $scope.key = "selectPlayer";

    $scope.reset = function(){
        $scope.query = {
            sport: $scope.sport,
            sortBy: "name"
        }
    }
    $scope.reset();

    const getPlayers = function() {
        return searchService.get("players/" +  queryService.getQueryString($scope.query, $scope.key)).then(function (response) {
            $scope.players = response.data.result;
            paginationService.setPage($scope.key, paginationService.buildPage(response));
        });
    }

    $scope.search = function () {
        paginationService.resetPage($scope.key);
        paginationService.pageQuery(getPlayers, $scope.key);
    }


    $scope.add = function(player){
        $scope.player = player;
        $mdDialog.hide(player)
    }

});
